module.exports = __webpack_public_path__ + "media/images/front/img_pd02-b0f41be24d1f7c53b9c7d104902e0969.jpg";